import type { SpacerProps } from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import { NumberField } from "./fields.js";
import type { WidgetInspectorProps } from "./registry.js";

export function SpacerInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as SpacerProps;

  return (
    <NumberField
      label="Height (px)"
      value={p.height}
      min={0}
      max={800}
      onChange={(v) => update(widget.id, { height: v })}
    />
  );
}
